// @ts-check
import { debounce } from "../utilities/debounce";
import { getAll } from "../utilities/querySelector";



const sections = getAll( '.icons-slider' );
sections.forEach( section => {

  const iconsWatcher = new IntersectionObserver( ( items ) => {
    items.forEach( item => {
      if ( item.isIntersecting ) {
        item.target.classList.remove( 'seethrough' );
      } else {
        item.target.classList.add( 'seethrough' );
      }
    } );
  }, {
    root: section,
    threshold: 0.95
  } );

  jQuery( section ).slick( {
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    swipeToSlide: true,
    speed: 600,
    cssEase: 'ease',
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: 0,
          variableWidth: false
        }
      }
    ]
  } );

  resetWatchers();
  window.addEventListener( 'resize', debounce( resetWatchers, 400 ) );

  function resetWatchers() {
    requestAnimationFrame( () => {
      const items = getAll( '.icon', section );
      items.forEach( item => {
        iconsWatcher.unobserve( item );
        iconsWatcher.observe( item );
      } );
    } );
  }
} );
